import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Media from './media';
import Title from './title';
import Advertorial from '../../advertorial/advertorial';
import RelatedSlider from '../../related_slider/related_slider';

export default class Header extends Component {
  shouldComponentUpdate() {
    return false;
  }

  render() {
    const {
      config,
      advertorial,
      tags,
      post,
      combinedAdModel,
      isLongPost,
      isVideoPost,
      videoAdData,
      isFirstPost,
      related,
      live
    } = this.props;

    return (
      <header className="post__header">
        {advertorial ? (
          <Advertorial tags={tags} adModel={combinedAdModel} />
        ) : (
          ''
        )}

        <div className="post__header-text">
          <Title
            config={config}
            isVideoPost={isVideoPost}
            isFirstPost={isFirstPost}
            location="beforevideo"
            post={post}
            tags={tags}
            live={live}
          />

          {isLongPost && !isVideoPost ? (
            <h2
              className="post__deck"
              dangerouslySetInnerHTML={{ __html: post.excerpt }}
            />
          ) : (
            ''
          )}
        </div>

        <Media
          post={post}
          videoAdData={videoAdData}
          isVideoPost={isVideoPost}
          isFirstPost={isFirstPost}
        />
        {isVideoPost ? (
          <div>
            <Title
              config={config}
              isVideoPost={isVideoPost}
              isFirstPost={isFirstPost}
              location="aftervideo"
              post={post}
              tags={tags}
              live={live}
            />
            <div
              className="post__article"
              dangerouslySetInnerHTML={{ __html: post.excerpt }}
            />
            <RelatedSlider
              title="Featured Videos"
              related={related}
              config={config}
              slideClassNames={['video-slide--horizontal']}
            />
          </div>
        ) : (
          ''
        )}
      </header>
    );
  }
}
Header.defaultProps = {
  related: []
};

Header.propTypes = {
  config: PropTypes.shape({}).isRequired,
  tags: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  advertorial: PropTypes.bool.isRequired,
  post: PropTypes.shape({}).isRequired,
  combinedAdModel: PropTypes.shape({}).isRequired,
  isFirstPost: PropTypes.bool.isRequired,
  isLongPost: PropTypes.bool.isRequired,
  videoAdData: PropTypes.shape({}).isRequired,
  isVideoPost: PropTypes.bool.isRequired,
  related: PropTypes.arrayOf(PropTypes.shape({})),
  live: PropTypes.bool.isRequired
};



// WEBPACK FOOTER //
// ./src/views/components/post/content/header.js